import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	routes: [
		{ // 无访问权限路由
			path: '/main',
			name: 'main',
			component: () => import('@/components/HelloWorld.vue'),
			
		},
    { // 无访问权限路由
			path: '/a',
			name: 'name',
			component: () => import('@/components/Company.vue'),
		},
    { // 主页
			path: '/',
			name: 'index',
			component: () => import('@/view/index.vue'),
		},
		{
			path: '/iframe',
			name: 'iframe',
			meta: {
				title: '店家详情'
			},
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ '@/view/Iframe.vue')
		}
	]
})
export default router;